import {
  Component
} from '@angular/core';

import { Subject } from 'rxjs/Subject';

import {
  SkyColorpickerOutput,
  SkyColorpickerMessage,
  SkyColorpickerMessageType
} from '../../core';


export class SkyColorpickerDemoComponent {
  public color1: any;
  public color2: any;
  public color3: any;
  public selectedColor1 = '#2889e5';

  public selectedOutputFormat1 = 'rgba';
  public selectedOutputFormat3 = 'rgba';
  public presetColors1 = [
    '#333333',
    '#888888',
    '#EFEFEF',
    '#FFF',
    '#BD4040',
    '#617FC2',
    '#60AC68',
    '#3486BA',
    '#E87134',
    '#DA9C9C',
    '#A1B1A7',
    '#68AFEF'
  ];
  public colorpickerController = new Subject<SkyColorpickerMessage>();
  public showResetButton = false;

  public onSelectedColorChanged(args: SkyColorpickerOutput) {
    console.log('You selected this color:', args);
  }

  public openColorpicker() {
    this.sendMessage(SkyColorpickerMessageType.Open);
  }

  public resetColorpicker() {
    this.sendMessage(SkyColorpickerMessageType.Reset);
  }

  public toggleResetButton() {
    this.sendMessage(SkyColorpickerMessageType.ToggleResetButton);
  }

  private sendMessage(type: SkyColorpickerMessageType) {
    const message: SkyColorpickerMessage = { type };
    this.colorpickerController.next(message);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-colorpicker-demo',
  template: `<h3>
  Colorpicker types and formats
</h3>

<div style="margin-bottom: 10px">
  <sky-colorpicker
    (selectedColorChanged)="onSelectedColorChanged($event)"
    #colorPickerExample1>
    <input
      [skyColorpickerInput]="colorPickerExample1"
      [(ngModel)]="color1"
      [presetColors]="presetColors1"
      [initialColor]="selectedColor1"
      [outputFormat]="selectedOutputFormat1">
  </sky-colorpicker>
</div>

<sky-definition-list>
  <sky-definition-list-content>
    <sky-definition-list-label>
      RGBA
    </sky-definition-list-label>
    <sky-definition-list-value
      *ngIf="color1?.rgba">
      {{color1?.rgba?.red}},
      {{color1?.rgba?.green}},
      {{color1?.rgba?.blue}},
      {{color1?.rgba?.alpha}}
    </sky-definition-list-value>
  </sky-definition-list-content>
  <sky-definition-list-content>
    <sky-definition-list-label>
      HSLA
    </sky-definition-list-label>
    <sky-definition-list-value
      *ngIf="color1?.hsla">
      {{color1?.hsla?.hue}},
      {{color1?.hsla?.saturation}},
      {{color1?.hsla?.lightness}},
      {{color1?.hsla?.alpha}}
    </sky-definition-list-value>
  </sky-definition-list-content>
  <sky-definition-list-content>
    <sky-definition-list-label>
      HSVA
    </sky-definition-list-label>
    <sky-definition-list-value
      *ngIf="color1?.hsva">
      {{color1?.hsva?.hue}},
      {{color1?.hsva?.saturation}},
      {{color1?.hsva?.value}},
      {{color1?.hsva?.alpha}}
    </sky-definition-list-value>
  </sky-definition-list-content>
  <sky-definition-list-content>
    <sky-definition-list-label>
      CMYK
    </sky-definition-list-label>
    <sky-definition-list-value
      *ngIf="color1?.cmyk">
      {{color1?.cmyk?.cyan}},
      {{color1?.cmyk?.magenta}},
      {{color1?.cmyk?.yellow}},
      {{color1?.cmyk?.key}}
    </sky-definition-list-value>
  </sky-definition-list-content>
</sky-definition-list>

<div style="margin-bottom: 10px">
  <sky-colorpicker #colorPickerExample2>
    <input
      type="text"
      [skyColorpickerInput]="colorPickerExample2"
      [(ngModel)]="color2">
  </sky-colorpicker>
</div>

<sky-definition-list>
  <sky-definition-list-content>
    <sky-definition-list-label>
      HEX
    </sky-definition-list-label>
    <sky-definition-list-value *ngIf="color2?.hex">
      {{color2?.hex}}
    </sky-definition-list-value>
  </sky-definition-list-content>
  <sky-definition-list-content>
    <sky-definition-list-label>
      RGBA CSS
    </sky-definition-list-label>
    <sky-definition-list-value *ngIf="color2?.rgbaText">
      <div style="margin-bottom: 5px;">
        {{color2?.rgbaText}}
      </div>
      <div style="border-color: #999;width: 28px;height: 28px;border-radius: 50%;border-width: 2px;border-style: solid;">
        <div [style.background-color]="color2?.rgbaText" style="width:24px;height:24px;    border-radius: 50%;">&nbsp;</div>
      </div>
    </sky-definition-list-value>
  </sky-definition-list-content>
</sky-definition-list>

<h3>
  Interacting with a colorpicker programmatically
</h3>

<sky-colorpicker
  [messageStream]="colorpickerController"
  [showResetButton]="showResetButton"
  (selectedColorChanged)="onSelectedColorChanged($event)"
  #colorPickerExample3>
  <input
    [skyColorpickerInput]="colorPickerExample3"
    [(ngModel)]="color3"
    [outputFormat]="selectedOutputFormat3">
</sky-colorpicker>

<sky-definition-list>
  <sky-definition-list-content>
    <sky-definition-list-label>
      HEX
    </sky-definition-list-label>
    <sky-definition-list-value *ngIf="color3?.hex">
      {{color3?.hex}}
    </sky-definition-list-value>
  </sky-definition-list-content>
  <sky-definition-list-content>
    <sky-definition-list-label>
      RGBA CSS
    </sky-definition-list-label>
    <sky-definition-list-value *ngIf="color3?.rgbaText">
      <div style="margin-bottom: 5px;">
        {{color3?.rgbaText}}
      </div>
      <div style="border-color:#999; width:28px; height:28px; border-radius:50%; border-width:2px; border-style:solid;">
        <div
          [style.background-color]="color3?.rgbaText"
          style="width:24px; height:24px; border-radius:50%;">
        </div>
      </div>
    </sky-definition-list-value>
  </sky-definition-list-content>
</sky-definition-list>

<p>
  <button
    type="button"
    class="sky-btn sky-btn-default"
    (click)="openColorpicker()">
    Open colorpicker
  </button>

  <button
    type="button"
    class="sky-btn sky-btn-default"
    (click)="resetColorpicker()">
    Reset colorpicker
  </button>

  <button
    type="button"
    class="sky-btn sky-btn-default"
    (click)="toggleResetButton()">
    Toggle reset button
  </button>
</p>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
